// Hierarchy View
const HierarchyView = ({ list }) => {
  if (!list?.length) return null;

  return (
    <div className="p-4 border rounded-2xl bg-gray-50 mb-2">
      <p className="text-sm font-semibold mb-3">Hierarchy</p>

      <div className="flex flex-col gap-2">
        {list.map((item, index) => (
          <div key={index} className="flex items-center">
            {/* Line + Dot */}
            <div className="flex flex-col items-center mr-3">
              <div className="w-2 h-2 bg-blue-500 rounded-full"></div>

              {index !== list.length - 1 && (
                <div className="w-[2px] h-6 bg-gray-300"></div>
              )}
            </div>

            {/* Content */}
            <div className="text-sm text-gray-700">
              <span className="font-medium">{item.label}:</span> {item.value}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default HierarchyView;